
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Quiz from './pages/Quiz'
import { FaBookQuran } from 'react-icons/fa6'
import { FiMenu } from "react-icons/fi";


const Dashboard = () => {
  const [showMenu, setShowMenu] = useState(false)
  const navigate = useNavigate();
  const mydata = localStorage?.getItem('admin')

  const handleLogout = () => {
    localStorage.removeItem('admin');
    navigate('/')
  }



  return (<>
    <div className='p-1 h-screen max-w-full m-auto bg-gradient-to-br from-green-500 to-indigo-500 via-violet-400'>
      <div className='fixed m-2'><FiMenu className='cursor-pointer' onClick={() => setShowMenu(!showMenu)} size={30} color='white' />
        {showMenu && <div className='relative menu bg-green-800 text-white rounded-xl p-2'>
          <div><small>Operated By:</small></div>
          <small>{mydata?.user}</small>
          <Link className='flex hover:bg-slate-400 rounded-xl mt-2' to={"/home"}><FaBookQuran size={25} /><span>Home</span></Link>
          <Link className='flex hover:bg-slate-400 rounded-xl mt-2' to={"/dashboard"}><FaBookQuran size={25} />Dashboard</Link>
          <Link className='flex hover:bg-slate-400 rounded-xl mt-2' to={"/questions"}><FaBookQuran size={25} />Questions</Link>
          <Link className='flex hover:bg-slate-400 rounded-xl mt-2' to={"/view"}><FaBookQuran size={25} />View</Link>
          <div className='text-center bgred rounded-full w-20 mt-2'>
            <button onClick={handleLogout}>LogOut</button></div>
        </div>}
      </div>
      <h3 className='flex justify-center align-middle gap-2 text-xl text-white m-1 p-1 font-serif bg-gradient-to-tl from-indigo-900 to-green-900 rounded-full arabic'>مسابقة القرآن الكريم <FaBookQuran /></h3>


      <div className='text-center bgcolor1 mt-2 rounded-lg'>

      </div>



      <section id='view' className='rounded-xl'>
        <Quiz />
      </section>

    </div>
  </>

  )
}

export default Dashboard
